module.exports = __webpack_public_path__ + "static/media/qty-decimal-point-0-preview.719ba1fd.png";